import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  email?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/password-reset')({
  staticData: { team: 'users-infra' },
  validateSearch: (search: Partial<SearchParams>): SearchParams => search,
});
